{
  "action": {
    "ok": "OK",
    "cancel": "Cancel",
    "save": "Save",
    "saved": "Saved",
    "close": "Close",
    "yes": "Yes",
    "no": "No",
    "delete": "Delete",
    "remove": "Remove",
    "add": "Add",
    "edit": "Edit",
    "rename": "Rename",
    "retry": "Retry",
    "reset": "Reset",
    "apply": "Apply",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "done": "Done",
    "refresh": "Refresh",
    "copy": "Copy",
    "copied": "Copied",
    "open": "Open",
    "start": "Start",
    "stop": "Stop",
    "pause": "Pause",
    "resume": "Resume",
    "continue": "Continue",
    "clear": "Clear",
    "search": "Search",
    "loading": "Loading…",
    "saving": "Saving…",
    "searchPlaceholder": "Search…",
    "always": "Always",
    "deny": "Deny",
    "undo": "Undo",
    "all": "All"
  },
  "confirm": {
    "title": "Approval required: {{tool}}",
    "descriptionEdit": "The agent wants to modify a file. Review the request below and decide whether to proceed.",
    "descriptionTool": "The agent wants to run this tool. Review the request below and decide whether to proceed.",
    "fileModification": "File modification",
    "toolExecution": "Tool execution",
    "riskSuffix": "{{risk}} risk",
    "command": "Command",
    "inputLabel": "Input:",
    "trustSuggestionTitle": "Trust pattern suggestion",
    "trustSuggestionHint": "Picking Always will whitelist matching calls for this project.",
    "yoloDestructiveNote": "YOLO is on. This prompt is still shown because the request was classified as destructive.",
    "skipApprovalsTitle": "Skip future approvals",
    "skipApprovalsHint": "Enable YOLO mode and the agent runs without asking. Destructive operations still prompt.",
    "enableYoloTitle": "Enable YOLO mode (auto-approve this and future non-destructive calls)",
    "enableYoloBtn": "Enable YOLO",
    "denyAlways": "Deny always",
    "denyAlwaysTitle": "Reject this and all future calls matching the pattern (d)",
    "noTitle": "Reject this single call (Esc / n)",
    "alwaysTitle": "Approve and remember the pattern for the project (a)",
    "yesTitle": "Approve this single call (y)"
  },
  "status": {
    "connected": "Connected",
    "disconnected": "Disconnected",
    "connecting": "Connecting…",
    "reconnecting": "Reconnecting…",
    "ready": "Ready",
    "error": "Error",
    "offline": "Offline",
    "online": "Online",
    "live": "Live",
    "budgetWarning": "budget warning",
    "running": "Running",
    "inProgress": "In Progress",
    "working": "working"
  },
  "time": {
    "justNow": "just now",
    "secondsAgo_one": "{{count}} second ago",
    "secondsAgo_other": "{{count}} seconds ago",
    "minutesAgo_one": "{{count}} minute ago",
    "minutesAgo_other": "{{count}} minutes ago",
    "hoursAgo_one": "{{count}} hour ago",
    "hoursAgo_other": "{{count}} hours ago",
    "daysAgo_one": "{{count}} day ago",
    "daysAgo_other": "{{count}} days ago",
    "compactSecondsAgo": "{{count}}s ago",
    "compactMinutesAgo": "{{count}}m ago",
    "compactHoursAgo": "{{count}}h ago"
  },
  "error": {
    "title": "Something went wrong",
    "body": "A rendering error occurred. Your session is still active on the server — reloading will pick up where you left off.",
    "reload": "Reload page",
    "tryAgain": "Try again"
  },
  "sparkline": {
    "noActivity": "No activity",
    "noActivityYet": "No activity yet",
    "activityMax": "Activity sparkline: max {{count}} events",
    "activityPeak": "Activity sparkline — peak {{count}} events/bucket"
  }
}
